import { memo, useEffect } from "react";

import { LoadingOverlay } from "../../../../components";
import {
  ReportSummaryHeader,
  ReportSummarySubheader,
  ReportSummaryTopHeader
} from "../../components";

import { COMPONENTS_MAP } from "../../components/report_summary/consts";

import { useRlNavContext } from "../../../commons/rl_nav/hooks";
import useParanoidMode from "../../../paranoid-mode/hooks/useParanoidMode";
import { PDFExport } from "../../components/report_summary/@types/PDFExport";
import { useGetReportSummary, useLocalSampleSummaryParams } from "../../hooks";
import useAutoReclassify from "../../hooks/useAutoReclassify";
import useGetSelectedLayoutDetails from "../../hooks/useGetSelectedLayoutDetails";
import styles from "./report-summary.module.scss";
import { shouldCollapseNavbar } from "./utils";

const ReportSummaryContainer = ({ isPdfView }: PDFExport) => {
  const { setExpanded } = useRlNavContext();
  const { hash, sourceId, relationshipId } = useLocalSampleSummaryParams();
  const { data: report } = useGetReportSummary(hash, sourceId, relationshipId);

  const { paranoidModeConfig } = useParanoidMode();

  const { layoutDetails, isLoading, selectedLayout } =
    useGetSelectedLayoutDetails();

  useAutoReclassify({
    sha1: hash,
    classification: report?.threat_status,
    classificationSource: report?.classification_source,
    classificationReason: report?.classification_reason.code,
    paranoidModeConfig
  });

  const { type, name } = selectedLayout ?? {};

  useEffect(() => {
    setExpanded(!shouldCollapseNavbar(type ?? "", name ?? ""));
  }, [type, name]);

  if (isLoading) {
    return (
      <>
        <LoadingOverlay />
        <img
          className="summary-basic-top__placeholder-image"
          src={`${window.tcbase.urls.static}images/report-summary-skeleton.png`}
        />
      </>
    );
  }

  return (
    <div className="flex flex-column flex-gap-4">
      <ReportSummaryTopHeader />
      <ReportSummaryHeader />
      <ReportSummarySubheader />
      <section className="flex flex-column flex-gap-4">
        {layoutDetails?.map((row, index) => (
          <div key={`report-summary-row-${index}`} className={styles.row}>
            {row.components.map(c => {
              const width = row.width / row.components.length;
              const { Component } = COMPONENTS_MAP[c] ?? {};

              return (
                <div key={c} className={styles[`item_${width}`]}>
                  <Component isPdfView={isPdfView} />
                </div>
              );
            })}
          </div>
        ))}
      </section>
    </div>
  );
};

export default memo(ReportSummaryContainer);
